import styles from './Outcomes.module.css';

const outcomes = [
  { icon: '⏱️', label: 'Reduce concession wait times' },
  { icon: '📈', label: 'Increase average order value' },
  { icon: '🎟️', label: 'Keep fans in their seats' },
  { icon: '⭐', label: 'Improve guest satisfaction' },
  { icon: '📊', label: 'Real-time operational visibility' },
];

function Outcomes() {
  return (
    <section className={`section ${styles.section}`} aria-labelledby="outcomes-heading">
      <div className="container">
        <span className="sectionLabel">Outcomes</span>
        <h2 id="outcomes-heading" className="sectionTitle">
          What venue teams get with ONI
        </h2>
        <p className="sectionSubtitle">
          Measurable wins for operators and a better experience for every fan in the building.
        </p>

        <ul className={styles.grid}>
          {outcomes.map((outcome) => (
            <li key={outcome.label} className={styles.card}>
              <span className={styles.icon} aria-hidden="true">
                {outcome.icon}
              </span>
              <span className={styles.label}>{outcome.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Outcomes;
